<template>
  <div>
    <div class="locked" v-if="plans.indexOf(user.plan) == -1">
      This feature is available on
      <v-chip v-for="plan in plans" :key="plan" class="mr-1">{{ plan }}</v-chip>plans.
      <router-link to="/plan" class="mr-1">Upgrade now</router-link>to use it.
      <div v-if="info">{{ info }}</div>
    </div>
    <div v-else>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import projectMixin from "./project/project-mixin";
export default {
  mixins: [projectMixin],
  props: ["plans", "info"]
};
</script>
<style scoped>
.locked {
  z-index: 1;
  margin: auto;
  text-align: center;
  border: 1px solid #efefef;
  border-radius: 5px;
  padding: 10px;
}
</style>